module.exports = __webpack_public_path__ + "img/gb119-86d-4-12_1.prt.cad015c0.jpg";